export enum LLMModelE {
  NONE = 'none',
  GPT_4_TURBO = 'gpt-4-turbo',
  GPT_4_TURBO_PREVIEW = 'gpt-4-turbo-preview',
  GPT_4_O = 'gpt-4o',
}
